<ng-container [ngSwitch]="viewMode">
  <ng-container *ngSwitchCase="'search-result'">
    <ng-container *ngTemplateOutlet="searchResultTemplate"></ng-container>
  </ng-container>
  <ng-container *ngSwitchCase="'collection-search-result'">
    <ng-container *ngTemplateOutlet="searchResultTemplate"></ng-container>
  </ng-container>
  <ng-container *ngSwitchCase="'card'">
    <ng-container *ngTemplateOutlet="cardTemplate"></ng-container>
  </ng-container>
  <ng-container *ngSwitchCase="'list'">
    <ng-container *ngTemplateOutlet="searchResultTemplate"></ng-container>
  </ng-container>
  <ng-container *ngSwitchCase="'widget'">
    <ng-container *ngTemplateOutlet="widgetTemplate"></ng-container>
  </ng-container>
  <ng-container *ngSwitchCase="'gallery-card'">
    <ng-container *ngTemplateOutlet="galleryTemplate"></ng-container>
  </ng-container>
</ng-container>

<!-- TEMPLATES -->
<ng-template #searchResultTemplate>
  <div class="collection-item-container result-view-container" data-cy="collection-item">
    <div class="result-view">
      <div
        class="collection-result-icon"
        [class.search-page-result]="pageType === 'search'"
        [class.collection-icon-bg]="!collection?.emoji"
        data-cy="collection-item-icon"
      >
        <ng-container *ngTemplateOutlet="collectionEmoji"></ng-container>
      </div>
      <div class="collection-info">
        <div class="title-emoji-container gap">
          <ng-container *ngTemplateOutlet="resultTitle"></ng-container>
          <ng-container *ngTemplateOutlet="favoriteIcon"></ng-container>
          <ng-container *ngTemplateOutlet="iconPin"></ng-container>
          <ng-container *ngIf="!collection.isShared">
            <ng-container *ngTemplateOutlet="lockIndication; context: { iconOnly: true }"></ng-container>
          </ng-container>
        </div>
        <ng-container *ngIf="showResultSections?.showBullets" #resultBullets tabindex="-1">
          <div class="bullets-section">
            @if (isExtension) {
              <ng-container *ngTemplateOutlet="creator"></ng-container>
              <ng-container *ngTemplateOutlet="editTime"></ng-container>
              <span class="bullet-divider"></span>
              <ng-container *ngTemplateOutlet="avatarList; context: { spreadAvatarsCount: 0, avatarText: 'Shared' }"></ng-container>
            } @else {
              <result-bullet
                *ngIf="bullets?.[0]"
                data-cy="result-bullet-container"
                tabindex="-1"
                [model]="bullets?.[0]"
                click-invoker
                (invoke)="onInvoke({ command: $event, trigger: 'mouse_click' })"
                data-cy="collection-item-create-time"
              >
              </result-bullet>
              <ng-container *ngTemplateOutlet="avatarList"></ng-container>
            }

            <ng-container *ngIf="bullets?.[1]">
              <span *ngIf="avatarsList?.length > 1" class="bullet-divider"></span>
              <result-bullet
                tabindex="-1"
                [model]="bullets?.[1]"
                click-invoker
                (invoke)="onInvoke({ command: $event, trigger: 'mouse_click' })"
                data-cy="collection-item-results-count"
              >
              </result-bullet>
            </ng-container>
          </div>
          <div *ngIf="tagsToDisplay?.length" class="tags search-result-view-tags" #tags>
            <ng-container *ngTemplateOutlet="collectionTag"></ng-container>
          </div>
        </ng-container>
      </div>
    </div>
    <div class="collection-search-buttons">
      <ng-container *ngTemplateOutlet="activeFavoriteIcon"></ng-container>
      <ng-container *ngTemplateOutlet="squareButton"></ng-container>
      <ng-container *ngTemplateOutlet="newIndication"></ng-container>
    </div>
  </div>
</ng-template>

<ng-template #cardTemplate>
  <div class="collection-item-container" data-cy="collection-item">
    <div class="collection-item-container">
      <div class="collection-info">
        <div class="avatar-edit-time-container">
          <ng-container *ngTemplateOutlet="creator"></ng-container>
          <ng-container *ngTemplateOutlet="editTime"></ng-container>
        </div>
        <ng-container *ngTemplateOutlet="squareButton"></ng-container>
        <div class="title-emoji-container gap">
          <ng-container *ngTemplateOutlet="emojiAndTitleAlign"></ng-container>
        </div>
        <ng-container *ngTemplateOutlet="resultSubtitle; context: { isCard: true }"></ng-container>
        <div *ngIf="tagsToDisplay?.length; else tagPadding" #tags class="tags card-view-tags">
          <ng-container *ngTemplateOutlet="collectionTag"></ng-container>
        </div>
        <ng-template #tagPadding>
          <div class="tag-padding"></div>
        </ng-template>

        <div class="item-footer">
          <div class="result-amount">
            <span *ngIf="resultsCount || resultsCount === 0"> {{ resultsCountDescription }} </span>
          </div>
          <ng-container *ngTemplateOutlet="iconPin"></ng-container>
          <ng-container *ngTemplateOutlet="favoriteIcon"></ng-container>
          <ng-container *ngIf="collection.isShared; else lockIndication">
            <ng-container *ngTemplateOutlet="avatarList; context: { sizeAvatar: '16px' }"></ng-container>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #widgetTemplate>
  <div class="collection-item-container" data-cy="collection-item">
    <div>
      <div class="collection-info widget">
        <div class="title-emoji-container gap widget">
          <ng-container *ngIf="!!collection?.emoji"> <ng-container *ngTemplateOutlet="collectionEmoji"></ng-container></ng-container>
          <ng-container *ngTemplateOutlet="resultTitle; context: { isWidget: true }"></ng-container>
          <ng-container *ngTemplateOutlet="resultsCountTemplate"></ng-container>
        </div>
        <ng-container *ngTemplateOutlet="showResultSections?.showSubtitleInSecondLine ? resultSubtitle : null"></ng-container>
        <div class="widget-title collection-actions" [class.visible]="contextMenuActive || sortPopupOpened">
          <ng-container *ngIf="!collection.isShared">
            <ng-container *ngTemplateOutlet="lockIndication; context: { iconOnly: true }"></ng-container>
          </ng-container>
          <ng-container *ngIf="avatarsList?.length > 1">
            <ng-container *ngTemplateOutlet="avatarList; context: { spreadAvatarsCount: 0 }"></ng-container>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #galleryTemplate>
  <gallery-view
    [model]="collection"
    [settings]="{
      showFooter: false,
      showThumbnail: false,
      showCheckbox: showResultSections.isEditable,
      showFavorite: showResultSections?.showFavoriteIcon && isFavorite,
      showDrag: showResultSections.isDraggable,
    }"
    (invoke)="galleryInvoke($event)"
    [contextMenuActive]="contextMenuActive"
    [checked]="checked"
    [selected]="selected"
    class="gallery-view"
  >
    <div class="gallery-view-container">
      <div class="gallery-view-emoji">
        <ng-container *ngTemplateOutlet="collectionEmoji; context: { emojiSize: 36 }"></ng-container>
      </div>

      <div class="item-footer" (click)="onClickEvent.emit(model)">
        <div class="gallery-card-footer">
          <ng-container *ngTemplateOutlet="resultTitle"></ng-container>
        </div>

        <ng-container *ngTemplateOutlet="iconPin"></ng-container>
        <ng-container *ngIf="collection.isShared; else lockIndication">
          <ng-container *ngTemplateOutlet="avatarList; context: { sizeAvatar: '16px' }"></ng-container>
        </ng-container>
        <ng-container *ngTemplateOutlet="newIndication"></ng-container>
      </div>
    </div>
    <ng-template let-value pTemplate="dragItem">
      <ng-content select=".drag-ind"></ng-content>
    </ng-template>
  </gallery-view>
</ng-template>

<!-- SUB-TEMPLATES -->
<ng-template #avatarList let-spreadAvatarsCount="spreadAvatarsCount" let-sizeAvatar="sizeAvatar" let-avatarText="avatarText">
  <avatar-list
    *ngIf="avatarsList?.length > 1 && !isViewPageItem"
    [model]="avatarsList"
    [tooltipHeader]="'Shared with'"
    [spreadAvatarsCount]="spreadAvatarsCount ?? 3"
    [avatarText]="avatarText"
    [tooltipLimit]="10"
    [sizeAvatar]="sizeAvatar ?? '20px'"
    [sizeAvatarCount]="sizeAvatar ?? '20px'"
    [fallbackIcon]="{ type: 'font', value: 'icon-shared-link' }"
  ></avatar-list>
</ng-template>
<ng-template #resultsCountTemplate>
  <div *ngIf="resultsCount || resultsCount === 0" class="result-amount-widget">{{ resultsCount }}</div>
</ng-template>

<ng-template #iconPin>
  <u-icon
    *ngIf="!!collection?.pinBy"
    class="collection-icon collection-pin-icon"
    [model]="{ type: 'font', value: 'icon-windows-full-pin' }"
    [styles]="{ fontSize: '12px' }"
    [pTooltip]="pinTooltip"
    tooltipPosition="top"
    tooltipStyleClass="u-tooltip"
    data-cy="collection-pinBy-indication"
  ></u-icon>
</ng-template>

<ng-template #resultTitle let-isWidget="isWidget">
  <result-title
    class="collection-item-title"
    [ngClass]="{ title: !isWidget }"
    [model]="{ text: collection?.title, tooltip: isWidget ? tooltip : '' }"
    [highlights]="collection?.highlights"
    [selected]="selected"
    [showSingleLineView]="true"
    [displayTooltipIfCut]="false"
    [showInlineTooltip]="isWidget"
    (click)="openCollectionItem($event)"
    data-cy="collection-item-title"
  >
  </result-title>
</ng-template>

<ng-template #emojiAndTitleAlign>
  <div
    #collectionTitle
    data-cy="collection-item-title"
    class="collection-title"
    [pTooltip]="tooltipText"
    tooltipPosition="top"
    tooltipStyleClass="u-tooltip"
  >
    <ng-container *ngTemplateOutlet="collectionEmoji; context: { emojiSize: 16 }"></ng-container>
    <span
      class="collection-title-text"
      data-cy="result-title-text"
      (click)="openCollectionItem($event)"
      [innerHTML]="collection?.title | highlight: collection?.highlights : 'default'"
    ></span>
  </div>
</ng-template>

<ng-template #editTime>
  <div class="last-edit" [pTooltip]="ownerInfoTooltip" tooltipPosition="top" tooltipStyleClass="u-tooltip">
    <ng-container *ngIf="isExtension; else fullTime">
      {{ displayModifiedTime }}
    </ng-container>
    <ng-template #fullTime> {{ preDisplayModifiedTime }}{{ displayModifiedTime }} </ng-template>
  </div>
</ng-template>

<ng-template #collectionEmoji let-emojiSize="emojiSize">
  <ng-container *ngIf="!!collection?.emoji; else collectionDefaultEmoji">
    <ng-container *ngTemplateOutlet="searchResultEmoji; context: { emojiSize: emojiSize }"></ng-container>
  </ng-container>
</ng-template>

<ng-template #searchResultEmoji let-emojiSize="emojiSize">
  <u-emoji [spriteEmojiSize]="emojiSize ?? 24" [unicode]="collection?.emoji"></u-emoji>
</ng-template>

<ng-template #collectionDefaultEmoji>
  <u-icon
    class="collection-default-emoji"
    *ngIf="collectionTypeIconMap[collection?.kind]"
    [model]="{ type: 'font', value: defaultIcon }"
    [styles]="{ color: collection?.kind === 'Live' ? 'var(--red-500)' : 'var(--color-text-primary)' }"
  ></u-icon>
</ng-template>

<ng-template #creator>
  <avatar
    *ngIf="!isLauncher && !(defaultIcon == 'icon-lot-of-cards' || defaultIcon == 'icon-draft')"
    [url]="avatarUrl"
    [size]="'16px'"
    [pTooltip]="isWidgetView ? preDisplayModifiedTime + 'by ' + owner?.email + ' ' + tooltipModifiedTime : ownerInfoTooltip"
    tooltipPosition="top"
    tooltipStyleClass="u-tooltip"
  ></avatar>
</ng-template>

<ng-template #collectionTag>
  <ng-container *ngFor="let tag of tagsToDisplay; let index = index">
    <div
      class="collection-tag static-tag"
      data-cy="collection-item-tag"
      [id]="index"
      [pTooltip]="tag.value?.length > 7 ? tag.value : ''"
      tooltipPosition="top"
      tooltipStyleClass="u-tooltip"
      (click)="onTagClick($event, tag)"
    >
      {{ tag.value | truncate: 7 }}
    </div>
  </ng-container>
  <div
    [id]="tagsToDisplay?.length"
    data-cy="collection-item-tag-extra"
    class="collection-tag extra-tag static-tag"
    [pTooltip]="hiddenTagsValues"
    tooltipPosition="top"
    tooltipStyleClass="u-tooltip"
  >
    {{ extraTagValue }}
  </div>
</ng-template>

<ng-template #favoriteIcon>
  <ng-container *featureFlagEnabled="DISABLED_FAVORITES_WORKSPACE_FEATURE_FLAG">
    <ng-container *ngIf="showResultSections?.showFavoriteIcon && isFavorite">
      <u-icon class="favorite-icon" [styles]="{ fontSize: '12px' }" [model]="{ type: 'font', value: 'icon-star-solid' }"></u-icon>
    </ng-container>
  </ng-container>
</ng-template>

<ng-template #activeFavoriteIcon>
  <ng-container *ngIf="showResultSections?.showFavoriteAction && isFavorite">
    <u-icon
      (click)="$event.stopPropagation(); collectionsService.toggleFavorite(collection)"
      class="active-favorite-icon"
      [styles]="{ fontSize: '14px' }"
      [model]="{ type: 'font', value: 'icon-star-solid' }"
      pTooltip="Remove from favorites"
      tooltipPosition="top"
      tooltipStyleClass="u-tooltip"
    ></u-icon>
  </ng-container>
</ng-template>

<ng-template #squareButton>
  <square-button
    *ngIf="showResultSections?.showContextMenu && !isViewPageItem"
    [active]="collectionContextMenuHelper?.source === 'actions'"
    class="square-button"
    [ngClass]="{ visible: contextMenuActive }"
    (click)="$event.stopPropagation(); openContextMenu($event)"
    (auxclick)="$event.stopPropagation(); openContextMenu($event)"
    (contextmenu)="$event.stopPropagation(); openContextMenu($event)"
    #actions
    data-cy="search-results-actions-kebab"
    >•••</square-button
  >
</ng-template>

<ng-template #newIndication>
  <new-indication *ngIf="showResultSections?.showNewIndication" [tooltip]="showResultSections.showNewIndication"></new-indication>
</ng-template>

<ng-template #resultSubtitle let-isCard="isCard">
  <div *ngIf="isCard && !collection?.description" class="subtitle-card-padding"></div>
  <result-subtitle
    class="description"
    *ngIf="collection?.description"
    [class.one-line]="!showResultSections?.showSubtitleInSecondLine"
    [class.tags-placeholder]="!tagsToDisplay?.length && isCard"
    [model]="{ text: collection?.description, tooltip: collection?.description }"
    [highlights]="collection?.highlights"
    data-cy="collection-item-subtitle"
  ></result-subtitle>
</ng-template>

<ng-template #lockIndication let-iconOnly="iconOnly">
  <div *ngIf="!isViewPageItem" class="private-collection-indication">
    <u-icon class="lock-icon" [model]="{ type: 'font', value: 'icon-lock' }" [styles]="{ fontSize: '14px' }"></u-icon>
    <span *ngIf="!iconOnly" class="lock-icon-text">Private</span>
  </div>
</ng-template>
